import { render, staticRenderFns } from "./addAssemble.vue?vue&type=template&id=94f83ccc&scoped=true&"
import script from "./addAssemble.vue?vue&type=script&lang=js&"
export * from "./addAssemble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f83ccc",
  null
  
)

export default component.exports